import { ChangeDetectorRef, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { FormObjectListComponent } from '../../../../shared/forms/form-object-list.component';
import { FormValidation } from '../../../../shared/forms/form-validation';
import { CorrectionEstimate } from '../../models/estimates/correction-estimate';
import { CorrectionEstimateComponent } from '../correction-estimate/correction-estimate.component';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'correction-estimate-list',
  templateUrl: './correction-estimate-list.component.html'
})
export class CorrectionEstimateListComponent extends FormObjectListComponent<CorrectionEstimateComponent, CorrectionEstimate> {
  @Input() form : UntypedFormGroup;
  @ViewChildren(CorrectionEstimateComponent) override objectForms: QueryList<CorrectionEstimateComponent>;

  constructor(changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }
  
  public override add(): void {
    // Check if the concern fields are filled.
    if (!FormValidation.isValid(this.form)) return;

    super.add(new CorrectionEstimate(null));
  }
}
